import component from './CardRowLayout';

export default component;
